var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingIlustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 305,
    viewBox: "0 0 416 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 129.48V110.98L226.5 125.48L214.5 129.48Z",
    fill: "#D9D9D9",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 75.98C178.2 47.58 196.5 33.8133 206.5 30.48H214L218.5 22.48L226.5 12.98L244 4.47998H258L268 12.98L278.5 20.48L280.5 17.98L287 14.48H298C304.667 18.98 318.2 28.48 319 30.48C319.8 32.48 321.333 43.3133 322 48.48C322.167 49.48 324 52.08 330 54.48C360.5 68.48 364.5 83.48 368 90.98C370.8 96.98 367.167 106.813 365 110.98C362.167 119.147 350.4 135.48 326 135.48C295.5 135.48 299.5 123.48 291.5 120.48C285.1 118.08 280.167 105.147 278.5 98.98C279.667 96.3133 281.7 89.68 280.5 84.48C279.3 79.28 274 78.98 271.5 79.48L265 84.48H261.5L246.5 81.48L239.5 71.98L221 84.48H206.5L199 79.48H196C194 79.3133 189 78.38 185 75.98Z",
    fill: "#232020",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 143.48C218.9 137.08 209.5 101.813 209 84.98L224.5 82.98L238 70.48L241 74.48L249.5 84.98H263L265.5 81.98L272.5 77.48L276.5 80.48L280.5 84.98V92.98L278 98.98L283.5 111.98C287.667 116.813 295.6 126.18 294 124.98C292.4 123.78 285 127.147 281.5 128.98L272.5 135.98C270.667 137.647 264.1 141.48 252.5 143.48Z",
    fill: "#C8C7C7",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 186.48H184C186.167 184.48 193.8 180.68 207 181.48C195.4 178.28 178.5 161.48 171.5 153.48L160.5 133.98H158.5L163.5 149.48V153.48L144.5 136.48L143 139.48L157 154.98H153L132.5 147.98H129.5L132.5 151.98L147.5 159.48L153 163.48L144.5 169.48L138.5 183.98L141 185.48L151.5 175.48L160.5 173.48L165.5 175.48V180.48L157 185.48L151.5 191.48L156 193.98L165.5 191.48L174.5 186.48Z",
    fill: "#C8C7C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188 193.98C208.8 188.38 233.667 209.313 243.5 220.48L239.5 236.98L236.5 235.48L226 227.98H215L206.5 217.98L204.5 216.98L202.5 222.98L204.5 227.98L196.5 225.98H191.5L188 222.98L183 219.98L182.5 213.98L190 203.48H181.5L171 213.98L169.5 211.48C169.333 207.98 172.8 199.58 188 193.98Z",
    fill: "#C8C7C7",
    stroke: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218 249.48L230 229.48L231 229.98L237.5 235.98V242.48L222.5 259.48H218V249.48Z",
    fill: "#E9E9E9",
    stroke: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411 211.48C419.8 221.48 408.667 274.647 402 299.98H397.5C398.333 266.314 402.2 201.48 411 211.48Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M393 299.98H397.5M397.5 299.98H402C408.667 274.647 419.8 221.48 411 211.48C402.2 201.48 398.333 266.314 397.5 299.98Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267 100.98C270.629 101.076 275.944 100.175 278.918 96.9802M278.918 96.9802C281.133 94.5997 282.049 90.9454 280 85.4802C275.2 72.6802 267 80.1469 263.5 85.4802C248.7 87.8802 241.667 76.8136 240 70.9802C209.5 99.9802 197.5 75.9802 197.5 77.9802C197.5 83.0052 166.5 76.9802 179.5 49.9802C189.9 28.3802 206.5 28.6468 213.5 31.4802C215.333 25.8135 223.2 12.5802 240 4.98016C256.8 -2.61984 271.333 13.4802 276.5 22.4802C281 17.8136 292.6 10.1802 303 16.9802C327.082 29.9802 317 47.9802 324.5 52.4802C341 54.9803 397.5 92.9801 350.5 127.48C305.5 150.98 280.779 114.48 278.918 96.9802Z",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209 85.98C208.5 100.48 215.8 132.08 249 142.48C257 143.48 259 143.98 265.5 141.48C272 138.98 275 129.98 284.5 128.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266 141.98C264.667 147.98 264.8 158.68 280 159.48",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5 151.48C282.833 155.813 270.7 171.18 259.5 197.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314 138.98C332 155.313 369.8 204.58 377 270.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298 242.98C293 245.813 276.1 245.78 248.5 222.98C245.7 220.98 244 222.48 243.5 223.48C243 230.647 238.3 247.78 223.5 258.98C220.3 261.38 218.833 258.647 218.5 256.98C216.833 253.48 216.5 243.58 228.5 231.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 264.98C231.5 275.147 262.9 295.68 300.5 296.48C318 292.48 338 272.98 354.5 244.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3 299.98C91 301.147 269.1 302.78 277.5 299.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 299.48C351.333 300.314 398 301.48 402 299.48C407 296.98 419.5 215.48 409 208.98C400.6 203.78 390.833 252.814 387 277.98",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 220.48C234.667 210.313 212.9 190.48 196.5 192.48C176 194.98 169.5 207.98 169 209.98C168.5 211.98 169.5 214.98 172 213.48C174.5 211.98 178 200.98 194.5 201.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 202.48C186.5 206.147 175.2 217.08 186 223.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198 206.98C194.5 207.813 189.2 211.28 188 218.48C186.8 225.68 192.5 227.48 196.5 227.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 211.48C196.333 215.647 189.7 224.98 204.5 228.98C205.7 227.78 203 223.48 201.5 221.48C202.333 219.48 204.5 215.78 206.5 216.98C209 218.48 212.5 229.98 226.5 228.98C231.7 229.38 236.667 235.147 238.5 237.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M209 182.48C200.833 178.813 182 168.28 172 155.48C166.8 141.08 161.833 133.813 160 131.98C159.333 131.813 156.6 132.58 157 134.98C157.5 137.98 165 150.48 165.5 154.48C166 158.48 150 132.98 143 136.98C139.5 138.98 157 153.98 158.5 156.98C149.667 152.147 131.6 143.58 130 147.98C128 153.48 149 156.98 153 163.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M184 186.48C182 186.48 177.5 186.48 175.5 186.48C173 186.48 160.5 196.98 153.5 192.98C146.5 188.98 157.5 189.48 166 177.48C168.5 170.48 150.5 175.48 150 175.98C149.5 176.48 141 187.98 139.5 186.48C138 184.98 137 181.98 143.5 171.48C147.1 167.48 154.667 164.313 158.5 163.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214 110.98C215 116.313 214 124.153 214 128.48C214 131.48 220 129.313 224.5 127.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 126.48C234.833 127.98 234.9 131.48 232.5 133.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 100.48C223.833 103.98 224.6 111.28 217 112.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0001 295.98C89.0001 276.147 73.1001 234.88 73.5001 228.48C74.7 227.28 80.6667 229.647 83.5 230.98C87.3333 243.314 96.2 269.18 101 273.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106 281.98C110.167 272.313 124.3 253.58 147.5 255.98C170.7 258.38 179.167 279.98 180.5 290.48C186.333 290.313 198.5 290.28 200.5 291.48C202.5 292.68 204 294.98 204.5 295.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122 281.98C121.833 280.313 123 276.28 129 273.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.501 246.98C129.901 244.18 126 241.98 122.001 243.98C120.626 244.668 118.601 247.48 119.001 249.48C119.501 251.98 124.501 250.48 127.501 246.98Z",
    fill: "#6F6F6F",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.21 244.421C151.154 244.474 151.005 241.072 147.929 239.675C146.872 239.195 144.078 239.372 142.875 240.592C141.37 242.118 144.529 244.356 148.21 244.421Z",
    fill: "#6F6F6F",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M171.364 255.061C174.735 256.395 176.035 252.41 173.094 249.469C172.084 248.459 168.787 247.453 166.872 248.339C164.478 249.447 167.15 253.393 171.364 255.061Z",
    fill: "#6F6F6F",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M186.75 270.934C190.121 272.268 191.421 268.283 188.481 265.342C187.47 264.332 184.174 263.326 182.259 264.212C179.865 265.32 182.536 269.266 186.75 270.934Z",
    fill: "#6F6F6F",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M125 249.98V252.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146 245.48V248.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 253.48L165 255.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 269.48L178 272.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 150.48C11 151.813 25.9 151.28 41.5 138.48C44.5 143.98 61 182.98 78 163.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3 154.48C13 170.313 39 200.48 66 184.48C86.5 172.332 84.5 161.48 83 159.98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74 162.48C75.3333 162.48 78.8 161.78 82 158.98C83.5 158.98 82 170.48 75.5 177.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77 164.48C78.1667 162.48 80.7 160.08 81.5 162.48",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 160.48C20.3333 160.647 27.5 159.68 33.5 154.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23 167.48C25 167.647 30.3 167.08 35.5 163.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33 173.48C34.1667 173.48 37.2 172.98 40 170.98",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 195.48C72.8333 194.98 82.3 191.48 85.5 181.48",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 199.98C82.1667 199.647 88.4 197.08 92 189.48",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4275 28.8856C66.3673 33.7215 77.2665 43.8951 97.3456 45.9022C95.5697 51.9102 79.6067 91.133 105.418 89.4002",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8298 29.9399C54.6803 48.2013 51.6802 87.9131 82.0752 95.7324C105.153 101.669 111.424 92.5902 111.427 90.4689",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.302 85.8617C104.243 86.8057 107.187 88.7661 111.429 89.0547C112.488 90.1167 103.286 97.1754 93.7401 97.516",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.004 89.398C106.244 88.8118 109.732 88.9107 108.598 91.1719",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8207 44.4439C66.7034 46.5678 72.4486 50.9596 80.3675 51.5361",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7481 53.2811C65.0424 54.815 69.1862 58.1675 75.4072 59.3073",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5611 64.5989C67.385 65.4249 69.881 67.2197 73.2743 67.7899",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0519 105.27C79.466 107.986 88.629 112.217 97.9694 107.421",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6332 116.237C82.7523 117.89 88.9713 120.491 96.8947 117.673",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M212 267.98C213.667 271.48 219.1 279.78 227.5 284.98",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingIlustration);
export default __webpack_public_path__ + "static/media/working_ilustration.151ada09f4919c69b5d1c3b917ff2f23.svg";
export { ForwardRef as ReactComponent };